import React from "react";

/**
 * Exporting various layout components.
 * Lazy-loaded imports are used for better performance.
 */

// Import the AppLayout component for common layout structure
export { default as AppLayout } from "./App/index.layout";

// Lazy-loaded imports for various layout components
export const MainLayout = React.lazy(() => import("./Main/index.layout"));
export const AuthLayout = React.lazy(() => import("./Auth/index.layout"));
export const AdminLayout = React.lazy(() => import("./Admin/index.layout"));
export const AdminPublicLayout = React.lazy(() =>
  import("./Admin/public.layout"),
);
export const AdminPrivateLayout = React.lazy(() =>
  import("./Admin/private.layout"),
);
